import { EditNoteIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";

interface NotesBadgeProperty {
    noteCount: number;
    size?: string;
    className?: string;
    onClick?: (e: any) => void;
}

export const NotesBadge = ({ noteCount, size = "small", className, onClick }: NotesBadgeProperty) => {
    if (noteCount === 0) {
        return <span />;
    }

    return (
        <Badge
            data-testid="notes-badge"
            color="warning"
            icon={<EditNoteIcon />}
            size={size}
            className={clsx("no-translate cursor-pointer font-bold text-black", className)}
            onClick={onClick}
        >
            {noteCount}
        </Badge>
    );
};
